import { Component, Input, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card',
  imports: [MatCardModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  private router = inject(Router);

  @Input() title = '';
  @Input() titleColor = 'black';
  @Input() subtitle: string | undefined = '';
  @Input() imageSrc: string | undefined = '';
  @Input() circleImgSrc: string | undefined = undefined;
  @Input() circleSizePx: string | undefined = '100px';
  @Input() sort = 0;
  @Input() titlePosition: 'after' | 'below' | undefined = 'after';
  @Input() link: string | undefined = '';

  onClick(): void {
    if (this.link) {
      void this.router.navigate([this.link]);
    }
  }
}
